import axios from 'axios';

console.log(`${process.env.REACT_APP_PUBLIC_API}/auth/login`);

const API = axios.create({baseURL: `${process.env.REACT_APP_PUBLIC_API}`});

export const LogIn = async (data) => await axios.post(`${process.env.REACT_APP_PUBLIC_API}/auth/login`, data);
